import {
  OptimizeByName,
  OptimizeAcrossName,
} from 'common/src/modules/optimization/optimization.types';
import { z } from 'zod';
import { baseCardSchema } from './baseSchemas';
import { NodeType } from 'common/src/modules/nodes/nodes.types';

// LLM-compatible schema definition
const optimizationNodeOutputSchema = z.object({
  name: z.string().describe('The name of the output'),
});

const optimizationCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.GENERAL_OPTIMIZATION),
  configuration: z.object({
    optimizeBy: z.nativeEnum(OptimizeByName),
    optimizeGroup: z
      .nativeEnum(OptimizeAcrossName)
      .describe(
        `The group to optimize across, use ${OptimizeAcrossName.Campaign} if not specified by the user`,
      ),
  }),
  variationsCount: z.number(),
  outputs: z.array(optimizationNodeOutputSchema).min(2),
});

export {optimizationCardSchema, optimizationNodeOutputSchema};
